exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apc-react-body .save-indicator {\n  position: fixed;\n  left: 50%;\n  transform: translate(-50%, 0) translateY(0);\n  pointer-events: none;\n  opacity: 0.7;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  background-color: #defaee;\n  color: #06db82;\n  width: 175px;\n  height: 40px;\n  border-radius: 5px;\n  transition: opacity 0.25s, transform 0.25s;\n  z-index: 1000; }\n  .apc-react-body .save-indicator.save-indicator-hidden {\n    opacity: 0;\n    transform: translate(-50%, 0) translateY(10px); }\n", ""]);

// exports
